export default {
  setLeads ({ commit }, payload) {
    commit('setLeads', payload)
  },

  setDesempenho ({ commit }, payload) {
    commit('setDesempenho', payload)
  },

  setRankNovos ({ commit }, payload) {
    commit('setRankNovos', payload)
  },

  setRankLeads ({ commit }, payload) {
    commit('setRankLeads', payload)
  },

  setRankUsados ({ commit }, payload) {
    commit('setRankUsados', payload)
  },

  setRankConsorcio ({ commit }, payload) {
    commit('setRankConsorcio', payload)
  },

  setHistoricoRank ({ commit }, payload) {
    commit('setHistoricoRank', payload)
  },

  setEmpresas ({ commit }, payload) {
    commit('setEmpresas', payload)
  }
}
